'use strict';

(function ($, Drupal, once) {

  Drupal.behaviors.changeLocation = {
    attach: (context, settings) => {
      const regionSelector = '.change-region--link';
      const modalSelector = '#block-ethiconproductlocalizationmodalblock';

      $(once('#block-ethiconproductlocalizationmodalblock', regionSelector, context)).each(function () {
        $(this).on('click', function() {
          $(modalSelector).modal('show');
        });
      });
    }
  };

})(jQuery, Drupal, once);
